import { render, staticRenderFns } from "./BlockColorHeader.vue?vue&type=template&id=09affe75&"
import script from "./BlockColorHeader.vue?vue&type=script&lang=js&"
export * from "./BlockColorHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports